/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IUndergroundItemPresenter {
  /** ID линии метро на ЦИАНе **/
  cianId?: TUndergroundItemPresenter_CianId;
  /** Полный заголовок **/
  fullName?: TUndergroundItemPresenter_FullName;
  /** Гео тип адресного элемента **/
  geoType?: TUndergroundItemPresenter_GeoType;
  /** ID метро **/
  id?: TUndergroundItemPresenter_Id;
  /** Основная станция метро **/
  isDefault?: TUndergroundItemPresenter_IsDefault;
  /** Цвет линии метро, hex **/
  lineColor?: TUndergroundItemPresenter_LineColor;
  /** ID линии метро **/
  lineId?: TUndergroundItemPresenter_LineId;
  /** Название **/
  name?: TUndergroundItemPresenter_Name;
  /** Кверистринг для гео элемента **/
  qs?: TUndergroundItemPresenter_Qs;
  /** Год постройки метро для строящейся станции **/
  releaseYear?: TUndergroundItemPresenter_ReleaseYear;
  /** Сокращенный заголовок **/
  shortName?: TUndergroundItemPresenter_ShortName;
  /** Время в пути в минутах до метро, мин **/
  time?: TUndergroundItemPresenter_Time;
  /** Заголовок **/
  title?: TUndergroundItemPresenter_Title;
  /** Способ передвижения до метро **/
  transportType?: TUndergroundItemPresenter_TransportType;
  /** Тип сущности **/
  type?: TUndergroundItemPresenter_Type;
  /** Является ли станция метро строящейся **/
  underConstruction?: TUndergroundItemPresenter_UnderConstruction;
}

export type TUndergroundItemPresenter_CianId = null | number;

export type TUndergroundItemPresenter_FullName = null | string;

export type TUndergroundItemPresenter_GeoType = null | EGeoType;

export enum EGeoType {
  /** Страна **/
  Country = 'country',
  /** Район **/
  District = 'district',
  /** Дом **/
  House = 'house',
  /** Местоположение **/
  Location = 'location',
  /** ЖД **/
  Railway = 'railway',
  /** Шоссе **/
  Road = 'road',
  /** Улица **/
  Street = 'street',
  /** Метро **/
  Underground = 'underground',
}
export type TUndergroundItemPresenter_Id = null | number;

export type TUndergroundItemPresenter_IsDefault = null | boolean;

export type TUndergroundItemPresenter_LineColor = null | string;

export type TUndergroundItemPresenter_LineId = null | number;

export type TUndergroundItemPresenter_Name = null | string;

export type TUndergroundItemPresenter_Qs = null | string;

export type TUndergroundItemPresenter_ReleaseYear = null | number;

export type TUndergroundItemPresenter_ShortName = null | string;

export type TUndergroundItemPresenter_Time = null | number;

export type TUndergroundItemPresenter_Title = null | string;

export type TUndergroundItemPresenter_TransportType = null | ETransportType;

export enum ETransportType {
  /** На транспорте **/
  Transport = 'transport',
  /** Пешком **/
  Walk = 'walk',
}
export type TUndergroundItemPresenter_Type = null | EType;

export enum EType {
  /** Страна **/
  Country = 'country',
  /** Район **/
  District = 'district',
  /** Дом **/
  House = 'house',
  /** Местоположение **/
  Location = 'location',
  /** ЖД **/
  Railway = 'railway',
  /** Шоссе **/
  Road = 'road',
  /** Улица **/
  Street = 'street',
  /** Метро **/
  Underground = 'underground',
  /** Метро **/
  Metro = 'metro',
}
export type TUndergroundItemPresenter_UnderConstruction = null | boolean;
